import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface SearchTab {
    key: string;
    label: string;
    icon: IconProp;
    isLoading: boolean;
    preventDefault?: boolean;
    onClick?: (key: string) => void;
    data: any[];
}

export interface SelectedTabItem {
    id: number;
    type: string;
    name: string;
    price: number;
    quantity: number;
    duration: number;
}

export type OtherEntityType = 'products' | 'services' | 'tasks';

/**
 * Собирает выбранную позицию из результата поиска.
 *
 * `type` здесь обязателен: по нему заказ раскладывает позиции на услуги, товары
 * и задачи (`createEntitiesPayload`). Список в раскрытой вкладке отдавал сырую
 * сущность без него, и выбранное молча не попадало в сохранение.
 */
export const toSelectedTabItem = (entity, type: string): SelectedTabItem => ({
    id: entity.id,
    type,
    name: entity.name,
    price: entity.price,
    quantity: 1,
    duration: entity.duration,
});
